import { c as _c } from "react/compiler-runtime";
import cn from 'classnames';
import { forwardRef, useEffect, useRef } from 'react';
import styles from './InputCheckbox.module.scss';
function useForwardedRef(ref) {
  const innerRef = useRef(null);
  useEffect(() => {
    if (!ref) return;
    if (typeof ref === 'function') {
      ref(innerRef.current);
    } else {
      ref.current = innerRef.current;
    }
  });
  return innerRef;
}
const InputCheckbox = forwardRef((t0, forwardedRef) => {
  const $ = _c(33);
  const {
    labelText,
    register,
    errorMessage,
    valid,
    name,
    onChange,
    onClick,
    checked,
    id,
    className,
    parameter,
    children,
    classNameChild,
    disabled
  } = t0;
  const innerRef = useForwardedRef(forwardedRef);
  let t1;
  if ($[0] !== onChange) {
    t1 = event => {
      if (onChange) {
        onChange(event);
      }
    };
    $[0] = onChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleChange = t1;
  let t2;
  if ($[2] !== onClick) {
    t2 = (value, id_0) => {
      if (onClick) {
        onClick(value, id_0);
      }
    };
    $[2] = onClick;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleClick = t2;
  const t3 = !valid && errorMessage;
  let t4;
  if ($[4] !== className || $[5] !== t3) {
    t4 = cn(styles.label, className, {
      [styles.error]: t3
    });
    $[4] = className;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = cn(styles.input);
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== handleChange) {
    t6 = event_0 => handleChange(event_0);
    $[8] = handleChange;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== handleClick || $[11] !== id || $[12] !== parameter?.value) {
    t7 = () => handleClick(parameter?.value, id);
    $[10] = handleClick;
    $[11] = id;
    $[12] = parameter?.value;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== checked || $[15] !== disabled || $[16] !== id || $[17] !== innerRef || $[18] !== name || $[19] !== register || $[20] !== t6 || $[21] !== t7) {
    t8 = <input type="checkbox" className={t5} name={name} onChange={t6} onClick={t7} ref={innerRef} checked={checked} disabled={disabled} id={id} {...register} />;
    $[14] = checked;
    $[15] = disabled;
    $[16] = id;
    $[17] = innerRef;
    $[18] = name;
    $[19] = register;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className={styles.svg}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none"><path d="M14.1206 1.60059L6.18459 10.3278L3.88059 8.58277H2.60059L6.18459 14.4006L15.4006 1.60059H14.1206Z" fill="#6A8860" /></svg></div>;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== children || $[25] !== classNameChild || $[26] !== labelText) {
    t10 = <div className={classNameChild} data-testid="label-child">{labelText}{children}</div>;
    $[24] = children;
    $[25] = classNameChild;
    $[26] = labelText;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== id || $[29] !== t10 || $[30] !== t4 || $[31] !== t8) {
    t11 = <label htmlFor={id} className={t4} data-testid="label-inputcheckbox">{t8}{t9}{t10}</label>;
    $[28] = id;
    $[29] = t10;
    $[30] = t4;
    $[31] = t8;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  return t11;
});
export default InputCheckbox;